export default __webpack_public_path__ + "images/xrp_b3110e.svg";